import React, { useContext, useEffect, useRef, useState, useCallback } from 'react'
import fetchCategoryWiseProduct from '../helpers/fetchCategoryWiseProduct'
import displayINRCurrency from '../helpers/displayCurrency'
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa6'
import { Link } from 'react-router-dom'
import addToCart from '../helpers/addToCart'
import Context from '../context'

const HorizontalCardProduct = ({category, heading}) => {
    const [data,setData] = useState([])
    const [loading,setLoading] = useState(true)
    const loadingList = new Array(13).fill(null)

    const scrollElement = useRef()

    const { fetchUserAddToCart } = useContext(Context)

    const handleAddToCart = async(e, product)=>{
        console.log(product)
       await addToCart(e, product)
       fetchUserAddToCart()
    }

    const fetchData = useCallback(async() =>{
        setLoading(true)
        const categoryProduct = await fetchCategoryWiseProduct(category)
        setLoading(false)

        console.log("horizontal data",categoryProduct.data)
        setData(categoryProduct?.data)
    },[category])

    useEffect(()=>{
        fetchData()
    },[fetchData])

    const scrollRight = () =>{
        scrollElement.current.scrollLeft += 300
    }
    const scrollLeft = () =>{
        scrollElement.current.scrollLeft -= 300
    }


  return (
    <div className='container mx-auto px-4 my-6 relative'>

            <h2 className='text-2xl font-semibold py-4'>{heading}</h2>

                
           <div className='flex items-center gap-4 md:gap-6 overflow-scroll scrollbar-none transition-all' ref={scrollElement}>

            <button  className='bg-white shadow-md rounded-full p-1 absolute left-0 text-lg hidden md:block' onClick={scrollLeft}><FaAngleLeft/></button>
            <button  className='bg-white shadow-md rounded-full p-1 absolute right-0 text-lg hidden md:block' onClick={scrollRight}><FaAngleRight/></button> 

           {   loading ? (
                loadingList.map((product,index)=>{
                    return(
                        <div className='w-full min-w-[280px] md:min-w-[320px] max-w-[280px] md:max-w-[320px] h-36 bg-white rounded-sm shadow flex' key={index}>
                            <div className='bg-slate-200 h-full p-4 min-w-[120px] md:min-w-[145px] animate-pulse'>

                            </div>
                            <div className='p-4 grid w-full gap-2'>
                                <div className='font-medium text-base md:text-lg text-ellipsis line-clamp-1 text-black bg-slate-200 animate-pulse p-1 rounded-full'></div>
                                <p className='capitalize text-slate-500 p-1 bg-slate-200 animate-pulse rounded-full'></p>
                                <div className='flex gap-3 w-full'>
                                    <p className='text-green-600 font-medium p-1 bg-slate-200 w-full animate-pulse rounded-full'></p>
                                    <p className='text-slate-500 line-through p-1 bg-slate-200 w-full animate-pulse rounded-full'></p>
                                </div>
                                <button className='text-sm  text-white px-3 py-0.5 rounded-full w-full bg-slate-200 animate-pulse'></button>
                            </div>
                        </div>
                    )
                })
           ) : (
            data?.length > 0 ? (
                data.map((product, index) => (
                    <Link 
                        key={product?._id} 
                        to={"product/" + product?._id} 
                        className="w-full min-w-[280px] md:min-w-[320px] max-w-[280px] md:max-w-[320px] h-36 bg-white rounded-sm shadow flex flex-shrink-0"
                    >
                        <div className='h-full p-2 min-w-[120px] md:min-w-[145px] flex items-center justify-center bg-slate-50'>
                            <img 
                                src={product?.productImage?.[0]} 
                                alt={product?.productName} 
                                className='w-full h-full object-contain hover:scale-105 transition-all'
                            />
                        </div>
                        <div className='p-3 flex flex-col justify-between flex-1 overflow-hidden'>
                            <div>
                                <h2 className='font-medium text-sm md:text-base text-black line-clamp-2 mb-1'>
                                    {product?.productName}
                                </h2>
                                <p className='capitalize text-slate-500 text-xs md:text-sm'>
                                    {product?.category}
                                </p>
                            </div>
                            <div>
                                <div className='flex gap-2 mb-2'>
                                    <p className='text-green-600 font-medium text-sm md:text-base'>
                                        {displayINRCurrency(product?.sellingPrice)}
                                    </p>
                                    <p className='text-slate-500 line-through text-xs md:text-sm'>
                                        {displayINRCurrency(product?.price)}
                                    </p>
                                </div>
                                <button 
                                    className='text-xs md:text-sm bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded-full w-full transition-colors' 
                                    onClick={(e) => handleAddToCart(e, product)}
                                >
                                    Add to Cart
                                </button>
                            </div>
                        </div>
                    </Link>
                ))
            ) : (
                <p className="text-center text-gray-500 w-full py-8">No products available.</p>
            )
           )
               
            }
           </div>
            

    </div>
  )
}

export default HorizontalCardProduct